import { render, staticRenderFns } from "./sharedDb__form.vue?vue&type=template&id=490e4483"
import script from "./sharedDb__form.vue?vue&type=script&lang=js"
export * from "./sharedDb__form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports